import { Header, HomeVideoBanner } from '../../shared/components';
import { HomeAudioProvider } from '../../shared/contexts';

export const Home = () =>
  <HomeAudioProvider>
    <Header />
    <HomeVideoBanner />
  </HomeAudioProvider>

